import React, { useEffect, useState, useRef } from 'react'
import { createPortal } from 'react-dom'
import './index.css'

const KeepAlivePopup = ({ children, visible, onClose, position = 'bottom' }) => {
  const [mounted, setMounted] = useState(false)
  const [show, setShow] = useState(false)
  const [animate, setAnimate] = useState(false)
  const scrollPosition = useRef(0)

  // 控制 body 滚动
  useEffect(() => {
    if (visible) {
      // 记录当前滚动位置
      scrollPosition.current = window.scrollY || document.documentElement.scrollTop
      // 禁止滚动
      document.body.style.position = 'fixed'
      document.body.style.top = `-${scrollPosition.current}px`
      document.body.style.width = '100%'
    } else {
      // 恢复滚动
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      // 恢复滚动位置
      window.scrollTo(0, scrollPosition.current)
    }
  }, [visible])

  useEffect(() => {
    setMounted(true)
    return () => {
      setMounted(false)
      // 组件卸载时确保恢复滚动
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      window.scrollTo(0, scrollPosition.current)
    }
  }, [])

  useEffect(() => {
    if (visible) {
      setShow(true)
      setTimeout(() => {
        setAnimate(true)
      }, 0)
    } else {
      setAnimate(false)
      setTimeout(() => {
        setShow(false)
      }, 300)
    }
  }, [visible])

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  if (!mounted || !show) return null

  const getPositionStyle = () => {
    switch (position) {
      case 'bottom':
        return {
          bottom: 0,
          left: 0,
          right: 0,
          transform: animate ? 'translateY(0)' : 'translateY(100%)'
        }
      case 'top':
        return {
          top: 0,
          left: 0,
          right: 0,
          transform: animate ? 'translateY(0)' : 'translateY(-100%)'
        }
      case 'left':
        return {
          left: 0,
          top: 0,
          bottom: 0,
          transform: animate ? 'translateX(0)' : 'translateX(-100%)'
        }
      case 'right':
        return {
          right: 0,
          top: 0,
          bottom: 0,
          transform: animate ? 'translateX(0)' : 'translateX(100%)'
        }
      default:
        return {
          bottom: 0,
          left: 0,
          right: 0,
          transform: animate ? 'translateY(0)' : 'translateY(100%)'
        }
    }
  }

  return createPortal(
    <div className="keep-alive-popup">
      <div 
        className={`keep-alive-popup-mask ${animate ? 'show' : ''}`}
        onClick={handleClose}
      />
      <div 
        className="keep-alive-popup-content"
        style={getPositionStyle()}
      >
        {children}
      </div>
    </div>,
    document.body
  )
}

export default KeepAlivePopup